import React from 'react'
import TextInput from '../components/Input/TextInput'
import MarkdownInput from '../components/Input/MarkdownInput'
import ImageInputSecondary from '../components/Input/ImageInputSecondary'
import PrimaryButton from '../components/Button/PrimaryButton'
import FormSection from '../components/Card/FormSection'
import moment from 'moment-timezone'

const BeritaForm = ({ onSubmit, data, isLoading }) => {
  return (
    <form onSubmit={onSubmit} encType="multipart/form-data">
      <div className="flex flex-col gap-3 p-3 lg:pl-0">
        <FormSection
          title="Informasi"
          description="Isi konten yang akan masuk pada berita di aplikasi"
        >
          <TextInput
            label="Judul Berita"
            placeholder="Masukkan judul berita"
            type="text"
            name="title"
            required={true}
            defaultValue={data?.attributes?.title}
          />
          <div className="grid gap-4 sm:grid-cols-2 max-w-[520px]">
            <TextInput
              label="Tanggal Publikasi"
              type="date"
              name="date-tanggal"
              required={true}
              defaultValue={
                data?.attributes?.date
                  ? moment(data?.attributes?.date)
                      .tz('Asia/Jakarta')
                      .format('YYYY-MM-DD')
                  : null
              }
            />
            <TextInput
              label="Jam Publikasi"
              type="time"
              name="date-jam"
              required={true}
              defaultValue={
                data?.attributes?.date
                  ? moment(data?.attributes?.date)
                      .tz('Asia/Jakarta')
                      .format('HH:mm')
                  : null
              }
            />
          </div>
          <div className="max-w-[260px]">
            <TextInput
              label="Jumlah Pembaca"
              placeholder="Masukkan jumlah pembaca"
              type="number"
              name="viewerCount"
              required={true}
              defaultValue={data?.attributes?.viewerCount}
            />
          </div>
        </FormSection>

        <FormSection title="Konten" description="Masukkan isi konten berita">
          <MarkdownInput
            label="Deskripsi Singkat"
            placeholder="Masukkan isi berita"
            name="content"
            required={true}
            defaultValue={data?.attributes?.content}
          />
          <TextInput
            label="Pembuat Berita"
            placeholder="Masukkan nama pembuat berita. mis: Infokom Jakmania"
            type="text"
            name="creator"
            required={true}
            defaultValue={data?.attributes?.creator}
          />
        </FormSection>

        <FormSection
          title="Gambar"
          description="Tambahkan gambar untuk berita yang akan kamu upload."
        >
          <ImageInputSecondary
            name="banner"
            required={false}
            defaultValue={data?.attributes?.banner}
            width={375}
            height={240}
            maxFileSize={10485760}
          />
          <TextInput
            label="Sumber Gambar"
            placeholder="Masukkan sumber gambar"
            type="text"
            name="imgSource"
            required={false}
            defaultValue={data?.attributes?.imgSource}
          />
        </FormSection>

        <FormSection
          title="Ribbon"
          description="Kode warna hanya dapat diubah melalui developer."
        >
          <TextInput
            label="Tulisan"
            placeholder="Masukkan tulisan pada ribbon"
            type="text"
            name="ribbonText"
            required={false}
            defaultValue={data?.attributes?.ribbonText}
          />
        </FormSection>

        <div className="flex justify-end rounded-card border border-line bg-white shadow-card px-5 py-4">
          <PrimaryButton type="submit" loading={isLoading}>
            Simpan
          </PrimaryButton>
        </div>
      </div>
    </form>
  )
}

export default BeritaForm
